import { getApiWrapper, postApiWrapper,getRequest } from "./wrapper";
export const getNameList = async () => {
    const url = `https://demomeghwal.merasamaj.app/users/list/names`;
    console.log(url);
    const result = await getRequest(url);
    console.log(result)
    return result;
  }
